import { render, staticRenderFns } from "./Sensoren.vue?vue&type=template&id=4db000b4"
import script from "./Sensoren.vue?vue&type=script&lang=js"
export * from "./Sensoren.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports